// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l_Q1","toggle":"styles_toggle__1vQeY","preview":"styles_preview__3Qz9K"};